
export class LocalStorage   {

    constructor()   {}

    getItem(keyName, defaultValue)    {
        try {
            let str = localStorage.getItem(keyName);
            if(str === null)  return typeof(defaultValue) === 'string' ? defaultValue : null;
            return str;
        } catch(e) {
            return typeof(defaultValue) === 'string' ? defaultValue : null;
        }
    }

    setItem(keyName, keyValue)  {
        try {
            localStorage.setItem(keyName, keyValue);
        } catch(e) {
        }
    }

    removeItem(keyName)  {
        try {
            localStorage.removeItem(keyName);
        } catch(e) {
        }
    }

    clear()  {
        try {
            localStorage.clear();
        } catch(e) {
        }
    }
};

export default new LocalStorage();